<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<div class="content">
  <app-user-edit-details-form
    submitText="Register"
    (formSubmit)="registerUser($event)"
  ></app-user-edit-details-form>
  <span>Or</span>
  <div><a [routerLink]="'/admin/login'">Login</a>&nbsp;if you already have an account.</div>
</div>
